import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {message} from 'antd';
import {connect} from 'react-redux';

import ChangePasswordForm from './Form';
import PasswordPolicy from '../PasswordPolicy';
import {setNewPassword} from '../../cognito';
import Logo from '../../../components/Logo';

class ChangePasswordIndex extends Component {
  state = {
    confirmLoading: false,
    redirectToLogin: false
  };

  saveFormRef = (form) => {
    this.form = form;
  };

  validateForm = (event, callback) => {
    event.preventDefault();

    this.setState({confirmLoading: true});

    this.form.validateFields((err, values) => {
      if (err) {
        this.setState({confirmLoading: false});
      } else {
        callback(values);
      }
    });
  };

  handleChangePassword = (event) => {
    this.validateForm(event, (values) => {
      setNewPassword(this.props.cognito.user, values.password, this.props.cognito.userAttributes)
        .then(() => {
          message.success('Password updated successfully, please login');
          this.setState({redirectToLogin: true});
        })
        .catch((err) => {
          message.config({duration: 8});
          message.error(<PasswordPolicy/>);
          this.setState({confirmLoading: false});
        });
    });
  };

  render() {
    // How to redirect with ReactRouter v4:
    // https://tylermcginnis.com/react-router-programmatically-navigate/

    if (this.state.redirectToLogin) {
      return <Redirect to="/login"/>;
    }

    return (
      <div className="body-auth body-inner">
        <h5 className="text-center">Please Change Your Password</h5>
        <div className="box box-default">
          <div className="box-body">
            <section className="text-center">
              <Logo/>
            </section>
            <ChangePasswordForm
              ref={this.saveFormRef}
              handleSubmit={this.handleChangePassword}
              confirmLoading={this.state.confirmLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let resultState = {
    cognito: {}
  };
  if (state) {
    resultState = {
      cognito: state.cognito
    };
  }
  return resultState;
};

export default connect(
  mapStateToProps,
  null
)(ChangePasswordIndex);
